import {createStylesParams} from '@wix/tpa-settings';

export default createStylesParams<Record<string, never>>({});
